import { Input, InputProps } from '@/components/ui/input';
import useGeneratorStore from '@/state/generator-store';
import { cn } from '@/utils';
import React, { useState } from 'react';

interface SimplePromptInputProps extends InputProps {
  className?: string;
}

const OldPromptInput: React.FC<SimplePromptInputProps> = ({ className, ...props }) => {
  const [isOnFocus, setIsOnFocus] = useState(false);
  const { register } = useGeneratorStore((state) => ({
    register: state.register,
  }));

  return (
    <div
      className={cn('inline-flex bg-gray-900 w-full h-20 py-3 px-4 rounded-lg text-white text-lg relative', className)}
      style={{
        background: 'linear-gradient(#191A1B, #1E2021)',
        border: '1px solid #474A4C',
        boxShadow: 'inset 2px 2px 12px rgba(0, 0, 0, 1)',
      }}
    >
      <label className="absolute top-2 left-7 text-xs text-gray-400 pointer-events-none">
        <div className="font-pressura-mono text-[10px] font-normal leading-[1.5] text-left text-jen-orange">TEXT INPUT</div>
      </label>
      <Input
        className="w-full h-full bg-transparent border-none font-pressura-mono text-[16px] font-normal leading-[1.5] pt-6 text-left text-white placeholder-content-tertiary placeholder:text-slate-400/75 focus:outline-none"
        placeholder={isOnFocus ? '' : 'ELECTRO POP, SPARSE DRUMS, DRIVING BASS, UPBEAT...'}
        style={{
          boxShadow: 'none',
        }}
        {...register('prompt')}
        {...props}
        autoCorrect="off"
        autoComplete="off"
        autoCapitalize="off"
        onFocus={(e) => {
          setIsOnFocus(true);
        }}
        onBlur={(e) => {
          setIsOnFocus(false);
        }}
        spellCheck={false}
      />
    </div>
  );
};

export default OldPromptInput;
